/*
 * Galerie produit sur mobile : ajoute un compteur « 1 / N » et des points
 * par-dessus le diaporama Horizon (les miniatures restent dessous).
 */
(() => {
  const MAX_POINTS = 5;

  function installer(galerie) {
    const slideshow = galerie.querySelector('slideshow-component');
    const conteneur = slideshow?.querySelector('slideshow-container');
    if (!slideshow || !conteneur || conteneur.querySelector('.galerie-repere')) return;

    const total = slideshow.querySelectorAll('slideshow-slide').length;
    if (total < 2) return;

    const repere = document.createElement('div');
    repere.className = 'galerie-repere';
    repere.setAttribute('aria-hidden', 'true');

    const compteur = document.createElement('span');
    compteur.className = 'galerie-repere__compteur';

    const points = document.createElement('span');
    points.className = 'galerie-repere__points';
    const nbPoints = Math.min(total, MAX_POINTS);
    for (let i = 0; i < nbPoints; i += 1) points.append(document.createElement('span'));

    repere.append(compteur, points);
    conteneur.append(repere);

    const afficher = (index) => {
      compteur.textContent = `${index + 1} / ${total}`;
      const actif = total <= MAX_POINTS ? index : Math.round((index / (total - 1)) * (nbPoints - 1));
      [...points.children].forEach((point, i) => point.classList.toggle('is-actif', i === actif));
    };

    afficher(0);
    slideshow.addEventListener('slideshow:select', (event) => {
      if (event.target === slideshow) afficher(event.detail?.index ?? 0);
    });
  }

  const lancer = () => document.querySelectorAll('media-gallery').forEach(installer);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lancer);
  } else {
    lancer();
  }
})();
